import React, { useCallback, useEffect, useState } from 'react';
import { Form, Col } from 'react-bootstrap';
import dayjs from 'dayjs';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarEdit } from '@fortawesome/pro-solid-svg-icons';

import PopoverTrigger from '../../components/PopoverTrigger';
import ReportDatePicker from './ReportDatePicker';
import CHARTCOLORS from '../../helpers/chartColors';

const styles = {
  label: {
    display: 'flex',
  },
  inputStyle: {
    textAlign: 'center',
    marginRight: '10px',
  },
  buttonStyle: {
    fontSize: '22px',
    color: CHARTCOLORS[1],
  },
  buttonContainerStyle: {
    cursor: 'pointer',
    pointerEvents: 'auto',
    position: 'absolute',
    top: '57%',
    right: '3%',
  },
};

function ReportMonthRange(props) {
  const {
    major_label,
    label,
    default_date,
    min_date,
    max_date,
    payload_key,
    updatePayload,
    updateLocal,
    showPicker,
  } = props;

  const [currentDate, setCurrentDate] = useState('');
  const [dateString, setDateString] = useState('');

  const setDate = useCallback(
    (date) => {
      const new_date = dayjs.utc(date);
      setCurrentDate(new_date);
      updatePayload(payload_key + '_year', new_date.year());
      updatePayload(payload_key + '_month', new_date.month() + 1);
      updateLocal(payload_key + '_year', new_date.year());
      updateLocal(payload_key + '_month', new_date.month() + 1);
    },
    [payload_key, updatePayload, updateLocal]
  );

  useEffect(() => {
    setDate(default_date);
  }, [setDate, default_date]);

  useEffect(() => {
    if (currentDate) {
      let str = '';
      const local_date = dayjs(currentDate);
      if (payload_key === 'start') {
        str =
          local_date.format('MMMM YYYY') +
          ' - ' +
          local_date.month(local_date.month() + 11).format('MMMM YYYY');
      } else if (payload_key === 'end') {
        str =
          local_date.month(local_date.month() - 11).format('MMMM YYYY') +
          ' - ' +
          local_date.format('MMMM YYYY');
      }
      setDateString(str);
    }
  }, [currentDate, payload_key]);

  return (
    <Form.Group as={Col}>
      <Form.Label style={styles.label}>{major_label}</Form.Label>
      <Form.Control
        style={styles.inputStyle}
        size='sm'
        disabled
        value={dateString}
      />
      <div
        id='report-popover-button'
        style={styles.buttonContainerStyle}
        hidden={!showPicker}
      >
        <PopoverTrigger
          rootClose={true}
          popoverTitle={label}
          popoverContent={
            <ReportDatePicker
              currentDate={currentDate}
              setDate={setDate}
              minDate={min_date}
              maxDate={max_date}
            />
          }
          trigger='click'
          placement='bottom'
        >
          <FontAwesomeIcon
            style={styles.buttonStyle}
            icon={faCalendarEdit}
            id={'report-date-popover'}
          />
        </PopoverTrigger>
      </div>
    </Form.Group>
  );
}

ReportMonthRange.defaultProps = {
  updateLocal: (x, y) => {},
};

export default ReportMonthRange;
